import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Widget from './App';

ReactDOM.render(
  <React.StrictMode>
    <Widget />
  </React.StrictMode>,
  document.getElementById('root')
);

